export default function(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none" {...props}>
      <path d="M9 3.75V14.2515" stroke="#1A1B1F" strokewidth="1.125" strokelinecap="round" strokelinejoin="round"/>
      <path d="M14.2515 9.00146H3.75" stroke="#1A1B1F" strokewidth="1.125" strokelinecap="round" strokelinejoin="round"/>
    </svg>
  );
}